import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-scroll-to-top',
  standalone: false,
  templateUrl: './scroll-to-top.html',
  styleUrl: './scroll-to-top.scss',
})
export class ScrollToTop {
  isVisible = false;
  scrollThreshold = 600; // px before button appears

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    this.isVisible = scrollPosition > this.scrollThreshold;
  }

  scrollToTop(): void {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  }
}
